import { Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { useKeycloak } from "@react-keycloak/web";
import { useEffect, useState } from "react";
import Dropzone from "react-dropzone-uploader";
import { Controller, useForm } from "react-hook-form";
import { translate } from "react-switch-lang";
import { CardBody, Col, Form, FormGroup, Input, Label, Media, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { CourseDto } from "../../../../models/courseDto";
import { useHttpClient } from "../../../../security/hooks/axiosProvider";
import { Hours, Minuts } from "../../data/durationPickerData";
import ButtonComponent from "../components/buttonComponent";
import SpinnerComponent from "../components/spinnerComponent";
import styles from "./course.module.scss";
import pdfLogo from "../../../../assets/images/logo/pdfImage.png";
import videoLogo from "../../../../assets/images/logo/videoicon.png";

const CourseManager: React.FC<{
  t: (key: string) => {};
  manageCourse: any;
  isUpdateTrainingPath: boolean;
  modalState: boolean;
  setIsModalOpened: any;
  courseToBeUpdated?: CourseDto;
  getCoursesListPerPage: any;
  isUpdateCourse: boolean;
  moduleId: number;
  courseLenght: number;
}> = ({ t, modalState, setIsModalOpened, courseToBeUpdated, getCoursesListPerPage, isUpdateTrainingPath, manageCourse, isUpdateCourse, moduleId, courseLenght }) => {
  const {
    register: courseRegister,
    handleSubmit: coursHandleSubmit,
    control: courseControl,
    setValue,
    getValues,
    reset,
    formState: { errors: courseError, isValid },
  } = useForm<CourseDto>({ mode: "all", defaultValues: isUpdateCourse ? courseToBeUpdated : {} });
  const [support, setSupport] = useState(null);
  const [hours] = useState(Hours);
  const [minuts] = useState(Minuts);
  const { keycloak } = useKeycloak();
  const httpClient = useHttpClient(keycloak.authenticated);
  const [isVideoType, setIsVideoType] = useState(false);
  const [isPDFType, setIsPDFType] = useState(false);
  const [spinner, setSpeener] = useState<Boolean>(false);
  const [currentCourseFileName, setCurrentCourseFileName] = useState("");

  useEffect(() => {
    if (courseToBeUpdated) {
      fillForm();
    }
    // eslint-disable-next-line
  }, [courseToBeUpdated]);

  const formCancel = () => {
    onToggleModal();
    initForm();
  };

  const onToggleModal = () => {
    setIsModalOpened(false);
  };

  const fillForm = () => {
    reset(courseToBeUpdated);
    getSupportType();
    setCurrentCourseFileName(courseToBeUpdated.supportPath ? getSupportFileOriginalName(courseToBeUpdated.supportPath) : null);
  };

  const initForm = () => {
    if (courseToBeUpdated) {
      fillForm();
    } else {
      resetForm();
    }
  };

  const resetForm = () => {
    getCoursesListPerPage();
    setIsVideoType(false);
    setIsPDFType(false);
    deleteCurrentCoursePDF();
    reset(null);
  };

  const submitCourse = coursHandleSubmit(async (courseData: CourseDto) => {
    if (!isUpdateTrainingPath) {
      setSpeener(true);
      if (support) {
        if (isUpdateCourse && courseData.supportPath) deleteCourseSupport(courseData.supportPath);
        let formData = new FormData();
        formData.append("support", support);
        const responseData = await httpClient.current?.post(`/course/support/`+courseData?.courseType.toLowerCase() , formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        courseData.supportUrl = responseData.data?.fileUrl;
        courseData.supportPath = responseData.data?.filePath;
        
      }
      if (!isUpdateCourse) courseData.id = courseLenght + 1;
      manageCourse(courseData);
      onToggleModal();
      resetForm();
      setSpeener(false);
    } else {
      if (isUpdateCourse) {
        updateCourseInUpdatingTrainingPath(courseData);
      } else {
        createCourseInUpdatingTrainingPath(courseData);
      }
    }
  });

  const deleteCourseSupport = (path: string) => {
    httpClient.current?.delete(`/course/support`, {
      params: {
        filePath: path,
      },
    });
  };

  const updateCourseInUpdatingTrainingPath = async (courseData: CourseDto) => {
    if (support) {
      setSpeener(true);
      deleteCourseSupport(courseData.supportPath);
      let formData = new FormData();
      formData.append("support", support);
      const uploadRespons = await httpClient.current?.post(`/course/support/`+courseData?.courseType.toLowerCase(), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      courseData.supportUrl = uploadRespons.data?.fileUrl;
      courseData.supportPath = uploadRespons.data?.filePath;
      setSpeener(false);
    }
    await httpClient.current.put(`/course`, courseData, {
      headers: { "Content-Type": "application/json" },
    });
    onToggleModal();
    resetForm();
  };

  const createCourseInUpdatingTrainingPath = async (courseData: CourseDto) => {
    if (support) {
      setSpeener(true);
      let formData = new FormData();
      formData.append("support", support);
      console.log("url test /course/support/"+courseData?.courseType)
      const uploadData = await httpClient.current?.post(`/course/support/`+courseData?.courseType.toLowerCase(), formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      courseData.supportUrl = uploadData?.data?.fileUrl;
      courseData.supportPath = uploadData?.data?.filePath;
      setSpeener(false);
    }
    courseData.moduleId = moduleId;
    await httpClient.current.post(`/course`, courseData, {
      headers: { "Content-Type": "application/json" },
    });
    onToggleModal();
    resetForm();
  };

  const handleChangeStatus = ({ file }, status) => {
    if (status === "done") {
      setSupport(file);
      setCurrentCourseFileName(file.name);
    }
  };

  const getSupportType = () => {
    if (getValues("courseType") === null) {
      setIsVideoType(false);
      setIsPDFType(false);
    } else if (getValues("courseType") === "VIDEO") {
      setIsVideoType(true);
      setIsPDFType(false);
      setValue("supportUrl", null);
    } else if (getValues("courseType") === "PDF") {
      setIsPDFType(true);
      setIsVideoType(false);
      setValue("supportUrl", null);
    }
  };

  const onTypeChange = e => {
    setValue("courseType", e?.target?.value);
    getSupportType();
  };

  const deleteCurrentCoursePDF = () => {
    setCurrentCourseFileName(null);
  };

  const getSupportFileOriginalName = (path: string): string => {
    const pathSplit = path.split("/");
    const generatedFileName = pathSplit[pathSplit.length - 1];
    const generationSplit = generatedFileName.split("_");
    return generatedFileName.replace("_" + generationSplit[generationSplit.length - 1], "") + ".pdf";
  };

  const isFormValid = (): boolean => {
    if (isPDFType) {
      return isValid && !!currentCourseFileName;
    }

    if (isVideoType) {
      return isValid && !!currentCourseFileName;
    }

    return false;
  };

  const truncate = (fileName: string) => {
    return fileName.length > 15 ? fileName.substr(0, 14) + "..." : fileName;
  };

  return (
    <>
      <Modal isOpen={modalState} centered={true} size="xl" key={courseToBeUpdated?.id}>
        <ModalHeader toggle={onToggleModal}>{isUpdateCourse ? t("update_training_path") : "Nouveau cours"}</ModalHeader>
        <ModalBody>
          {spinner && <SpinnerComponent />}
          {!spinner && (
            <CardBody>
              <Form key={courseToBeUpdated?.id} className="needs-validation" noValidate={true}>
                <FormGroup>
                  <Grid container spacing={10}>
                    <Grid className={styles["grid_first_item"]} item md={6} xs={12}>
                      <InputLabel id="demo-simple-select-label">Titre</InputLabel>
                      <input className="form-control" type="text" placeholder="Titre du cours" {...courseRegister("title", { required: true })} />
                      {courseError.title && <p className={styles["error_message"]}>{t("signup_field_required")}</p>}
                    </Grid>
                    <Grid className={styles["grid_second_item"]} item md={6} xs={12}>
                      <InputLabel id="demo-simple-select-label">{t("course_duration")}</InputLabel>
                      <Controller
                        control={courseControl}
                        name="courseHours"
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <Select onChange={e => onChange(Number.parseInt(e.target.value.toString()))} value={value} defaultValue="">
                            {hours.map((info, index) => (
                              <MenuItem key={index} value={info}>
                                {info}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      :
                      <Controller
                        control={courseControl}
                        name="courseMinutes"
                        rules={{ required: true }}
                        render={({ field: { onChange, value } }) => (
                          <Select onChange={e => onChange(Number.parseInt(e.target.value.toString()))} value={value} defaultValue="">
                            {minuts.map((info, index) => (
                              <MenuItem key={index} value={info}>
                                {info}
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      />
                      {courseError.courseHours && courseError.courseMinutes && <p className={styles["error_message"]}>{t("signup_field_required")}</p>}
                    </Grid>
                  </Grid>
                </FormGroup>

                <Row>
                  <Col sm="12">
                    <InputLabel id="demo-simple-select-label">Type du support</InputLabel>
                  </Col>
                  <Col>
                    <FormGroup className="m-t-15 m-checkbox-inline mb-0 custom-radio-ml">
                      <div className="radio radio-secondary">
                        <Input id="radioinline1" type="radio" name="radio1" value="PDF" defaultChecked={isPDFType} style={{ height: "25px", width: "20px" }} onChange={onTypeChange} />
                        <Label className="mb-0" for="radioinline1">
                          <span>
                            <i className="fa fa-file-pdf" id={styles["pdf_icon"]}></i>
                          </span>
                        </Label>
                      </div>

                      <div className="radio radio-secondary">
                        <Input id="radioinline2" type="radio" defaultChecked={isVideoType} name="radio1" value="VIDEO" onChange={onTypeChange} />
                        <Label className="mb-0" for="radioinline2">
                          <span>
                            <i className="fa fa-video" id={styles["video_icon"]}></i>
                          </span>
                        </Label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>

                {isVideoType && !currentCourseFileName && (
  <FormGroup className={styles["drop_zone_formgroup"]}>
    <Dropzone
      addClassNames={{ dropzone: styles.Dropzone, input: styles.Input, inputLabel: styles.InputLabel }}
      onChangeStatus={handleChangeStatus}
      maxFiles={1}
      accept={"video/*"}
      multiple={false}
      canCancel={true}
      canRemove={true}
      inputContent={
        <div>
          <span className={styles["dropzone_content_text"]}>
            <i className="fa fa-plus"></i> {t("Choose_video")}
          </span>
        </div>
      }
    />
  </FormGroup>
)}
                
                {isPDFType && !currentCourseFileName && (
                  <FormGroup className={styles["drop_zone_formgroup"]}>
                    <Dropzone
                      addClassNames={{ dropzone: styles.Dropzone, input: styles.Input, inputLabel: styles.InputLabel }}
                      key="in"
                      onChangeStatus={handleChangeStatus}
                      maxFiles={1}
                      accept={"application/pdf"}
                      multiple={false}
                      canCancel={true}
                      canRemove={true}
                      inputContent={
                        <div>
                          <span className={styles["dropzone_content_text"]}>
                            <i className="fa fa-plus"></i> {t("Choose_support")}
                          </span>
                        </div>
                      }
                    />
                  </FormGroup>
                )}
                {isPDFType && currentCourseFileName &&(
                 
                  <div className={styles["pdf-container"]}>
                    <span>{truncate(currentCourseFileName)}</span>
                    <Media body src={pdfLogo} className={styles["pdf_logo"]} />
                    <span onClick={deleteCurrentCoursePDF} className={styles["icon-delete"]}>
                      <i className="fa fa-times-circle"></i>
                    </span>
                  </div>
                )}
               {isVideoType && currentCourseFileName && (
                  <div className={styles["pdf-container"]}>
                    <span>{truncate(currentCourseFileName)}</span>
                    <img src={videoLogo} alt="video icon" style={{ width: "50px", height: "auto" }} />
                          <span onClick={deleteCurrentCoursePDF} className={styles["icon-delete"]}>
                      <i className="fa fa-times-circle"></i>
                    </span>
                  </div>
                )}
                <Row className={styles["submit_button_row"]}>
                  <div>{isValid}</div>
                  <ButtonComponent onClick={() => submitCourse()} disable={!isFormValid()} buttonType={"button"} buttonText={"Enregistrer"} save={true} />
                  <ButtonComponent onClick={formCancel} disable={false} buttonType={"button"} buttonText={(t("cancel")).toString()} save={false} />
                </Row>
              </Form>
            </CardBody>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default translate(CourseManager);
